<template>
    <b-container>
        <h1>Education</h1>

        <b-alert variant="danger" :show="error != ''">{{ error }}</b-alert>

        <b-form inline class="my-3" @submit.prevent>
            <b-input placeholder="Id No" id="idNo" class="mr-2" v-model.number="filterForm.idNo"></b-input>
            <b-input placeholder="Name" class="mr-2" v-model="filterForm.name"></b-input>
            <b-select :options="departments" value-field="id" text-field="name" class="mr-2" v-model="filterForm.departmentId">
                <template v-slot:first>
                    <b-select-option :value="null"></b-select-option>
                </template>
            </b-select>
            <b-select :options="companies" value-field="id" text-field="name" class="mr-2" v-model="filterForm.companyId">
                <template v-slot:first>
                    <b-select-option :value="null"></b-select-option>
                </template>
            </b-select>

            <b-select :options="educationTypes" value-field="id" text-field="name" class="mr-2" v-model="filterForm.educationTypeId">
                <template v-slot:first>
                    <b-select-option :value="null"></b-select-option>
                </template>
            </b-select>

            <b-checkbox v-model="showMissing" class="mr-2">Missing</b-checkbox>

            <b-button @click="filterClick">Filter</b-button>

            <a href="#" @click.prevent="excelClick" class="ml-2"><img width="30" src="/icon_excel.png" ></a>
        </b-form>

        <b-table :items="items">
            <template v-slot:cell(idNo)="data">
                {{ data.value || '' }}
            </template>

            <template v-slot:cell(issueDate)="data">
                {{ data.value.substring(0, 10) }}
            </template>

            <template v-slot:cell(expiryDate)="data">
                {{ data.value ? data.value.substring(0, 10) : '' }}
            </template>
        </b-table>

        <ul class="pagination">
          <li class="page-item" :class="{ disabled: filterForm.page === 1 }"><a class="page-link" href="#" @click.prevent="prevPage">Previous</a></li>
          <li class="page-item" :class="{ disabled: filterForm.page >= totalPages }"><a class="page-link" href="#" @click.prevent="nextPage">Next</a></li>
        </ul>
    </b-container>
</template>

<script>
import axios from 'axios';

export default {
    data() {
        return {
            error: '',
            items: [],
            departments: [],
            companies: [],
            educationTypes: [],
            showMissing: false,
            filterForm: {
                idNo: '',
                name: '',
                departmentId: null,
                companyId: null,
                educationTypeId: null,
                page: 1
            },
            totalPages: 1
        }
    },
    methods: {
        excelClick() {
            let url = null;

            if (this.showMissing) {
                url = '/api/education/missing/excel';
            } else {
                url = '/api/education/excel';
            }
            
            const params = new URLSearchParams(url.search);
            
            params.append('idNo', this.filterForm.idNo);
            params.append('name', this.filterForm.name);
            params.append('companyId', this.filterForm.companyId || '');
            params.append('departmentId', this.filterForm.departmentId || '');
            params.append('educationTypeId', this.filterForm.educationTypeId || '');

            window.location.href = `${url}/?${params}`;
        },
        filterClick() {
            this.filterForm.page = 1;
            this.filter();
        },
        filter() {
            this.error = '';
            let url = '';
            
            if (this.showMissing) {
                url = '/api/education/missing';
            } else {
                url = '/api/education';
            }
            
            axios.get(url, { params: this.filterForm })
            .then(res => { 
                this.items = res.data.result
                this.filterForm.page = res.data.page;
                this.totalPages = res.data.totalPages;
            })
            .catch(() => { this.error = 'Failed to filter data' });
            },
        nextPage() {
            this.filterForm.page++;
            this.filter();
        },
        prevPage() {
            this.filterForm.page--;
            this.filter();
        }
    },
    created() {
        const educationQuery = axios.get('/api/education');
        const companyQuery = axios.get('/api/companies');
        const departmentQuery = axios.get('/api/departments');
        const educationTypeQuery = axios.get('/api/educationtypes');
        
        Promise.all([educationQuery, companyQuery, departmentQuery, educationTypeQuery])
        .then(res => {
            this.items = res[0].data.result;
            this.companies = res[1].data;
            this.departments = res[2].data;
            this.educationTypes = res[3].data;
        })
        .catch(() => {
            this.error = 'Failed to load data';
        });
    }
}
</script>

<style scoped>
    #idNo {
        width: 70px;;
    }
</style>